import { Text, Title } from '@mantine/core'
import { FC } from 'react'

import classes from './Error403.module.css'

const Error403: FC = () => {
  return (
    <>
      <div className={classes.label}>403</div>
      <Title className={classes.title}>Not Authorised!</Title>
      <Text color='dimmed' size='lg' align='center' className={classes.description}>
        You do not have permission to view this page.
      </Text>
    </>
  )
}

export { Error403 }
